import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Price.css";

const PricingUpper = () => {
  const products = [
    { name: "Music Distribution", icon: "/Images/pricing-icon/icon-music.svg" },
    {
      name: "Artist Insights",
      icon: "/Images/pricing-icon/i-artist-insights.svg",
    },
    {
      name: "Publishing Royalties",
      icon: "/Images/pricing-icon/icon-money.svg",
    },
    {
      name: "Music Promotion",
      icon: "/Images/pricing-icon/icon-announcement.svg",
    },
  ];

  return (
    <div className="pricing-page-upper" style={{ textAlign: "center", paddingTop: "100px", position: "relative", zIndex: 1 }}>
      <Container>
        <motion.h1 
          style={{ fontSize: "48px", fontWeight: 700, marginBottom: "20px", color: "#fff" }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Everything an artist needs <br />
          <span className="text-gradient">in one place</span>
        </motion.h1>
        <motion.div 
          style={{ color: "#94a3b8", fontSize: "16px", marginBottom: "40px" }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          All our plans include
        </motion.div>
        
        <div className="pricing-features-top">
          {products.map((product, index) => (
            <motion.div 
              key={index} 
              className="feature-box-top"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 + index * 0.1 }}
            >
              <img
                src={product.icon}
                alt={`${product.name} icon`}
                style={{ width: "48px", height: "48px", objectFit: "contain", filter: "drop-shadow(0px 0px 8px rgba(236,72,153,0.5))" }}
              />
              <span>
                {product.name.split(" ").map((word, i) => (
                  <React.Fragment key={i}>
                    {word}
                    {i < product.name.split(" ").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </span>
            </motion.div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default PricingUpper;
